import { InjectionToken } from '@angular/core';
import { IMarcheService } from './imarche.service';

export const ImarcheToken = new InjectionToken<IMarcheService>('ImarcheService');
